/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

/**
 * @module NavigationBackgroundOnScroll
 */
(function NavigationBackgroundOnScroll() {
    /**
     * handles the visibility of the scroll to top button
     *
     * @constructor
     */
    function NavigationBackgroundOnScroll(header) {
        /**
         * // local object availability
         * @type {NavigationBackgroundOnScroll}
         * @private
         */
        var _this = this;

        /**
         * @type {element}
         */
        this.header = header;

        /**
         * @method scrollVisibility
         * @returns {undefined}
         */
        this.handleScrolling = function (value) {
            document.body.style.overflow = value;
        };
        /**
         * @method scrollVisibility
         * @returns {undefined}
         */
        this.scrollVisibility = function () {
            var headerHeight = _this.header.offsetHeight;
            var scrollPosition = window.scrollY || document.scrollTop;
            if (headerHeight < scrollPosition) {
                _this.header.classList.add("js__has-background");
            } else {
                _this.header.classList.remove("js__has-background");
            }
        };

        /**
         * @method bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            document.addEventListener('scroll', _this.scrollVisibility);
            // When hovering over studios (nav-level-1) no scrolling of the page is possible
            const hoverElements = document.querySelectorAll('.main-nav--list-item.nav-level-1.sub');
            if (hoverElements) {
                hoverElements.forEach((element) => {
                    element.addEventListener('mouseenter', () => _this.handleScrolling('hidden'));
                    element.addEventListener('mouseleave', () => _this.handleScrolling('auto'));
                });
            }
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.bindEvents();
        };

        /**
         * initialize call
         */
        this.init();
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.NavigationBackgroundOnScroll = NavigationBackgroundOnScroll;
})();

$(function () {
    var header = document.querySelector('[data-html-element="header"]');
    if (header) {
        new window.Jumpers.NavigationBackgroundOnScroll(header);
    }
});
